import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { ExportPage } from "./pages/myView/export/exportPage";
import "./index.css";
//This has to be somewhere in the app for the extension methods to work
import "@repo/helpers/src/extensions";

const route = document.getElementById("root");
const page = route?.getAttribute("data-page");

createRoot(document.getElementById("root")).render(
	<StrictMode>
		{page === "my-view-v2-widget" ? (
			<ExportPage input={JSON.parse(document.getElementById("myview-export-data").textContent)} />
		) : (
			<App page={page} />
		)}
	</StrictMode>,
);
